import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/Shared/Shared.service'; 

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
    allowedRole: number[];
}
export const ROUTES: RouteInfo[] = [
    { path: '/admin/user/user-listing', title: 'User',  icon: 'person', class: '', allowedRole: [1,2,3] },
    { path: '/admin/company/company-listing', title: 'Company',  icon:'business', class: '', allowedRole: [1,2] },
    { path: '/admin/product/product-listing', title: 'Product',  icon:'content_paste', class: '', allowedRole: [1,2] },
    { path: '/admin/news/news-listing', title: 'News',  icon:'library_books', class: '', allowedRole: [1,2] },
    { path: '/admin/event/event-listing', title: 'Event',  icon:'event', class: '', allowedRole: [1,2] },
    { path: '/admin/repository/repository-listing', title: 'Repository',  icon:'source', class: '', allowedRole: [1,2] },
    { path: '/admin/newscomment/newscomment-listing', title: 'User Comment',  icon:'comment', class: '',  allowedRole: [1,2] },
    { path: '/admin/report/userlog', title: 'Report',  icon:'insert_chart', class: '',  allowedRole: [1] },
    { path: '/admin/importdata', title: 'Import Data',  icon:'cloud_upload', class: '',  allowedRole: [1,2] },
    { path: '/admin/rssfeed/import-news', title: 'RSS Feed',  icon:'rss_feed', class: '',  allowedRole: [1] },
  ];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor(
    private sharedService : SharedService,
  ) { }

  ngOnInit() {
    //Get Site Modules/items link for user 
    let siteMenu = [];
    siteMenu = this.sharedService.getSiteMenu('AdminModules');
    //console.log(siteMenu.length)
    ROUTES.length = 0;
    for (var i = 0; i < siteMenu.length; i++) {
      ROUTES.push(siteMenu[i]);
    }
    //console.log(ROUTES)
    this.menuItems = ROUTES.filter(menuItem => menuItem.allowedRole.includes(Number(this.sharedService.getUserDetail('RoleId'))));
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}
